import { membershipService } from '@libs/data-access/queries'
import { Alert, Button, Flex } from '@libs/ui/ds'
import { useMemberPageTranslation } from '@libs/utils/translations'
import type { FC } from 'react'
import React, { useState } from 'react'
import { deleteContract } from 'snap-redux/modules/contracts'
import { useActions } from 'snap-redux/utils'

type Props = {
  close(): void
  contractId: number
  formLoading: boolean
  futureShifts: number[]
  hideDeleteConfirm(): void
  setFormError(errors: any): void
  onSubmitSuccess?: () => void
}
const DeleteConfirmMessage: FC<Props> = ({
  close,
  contractId,
  formLoading,
  futureShifts,
  hideDeleteConfirm,
  setFormError,
  onSubmitSuccess
}) => {
  const { t, tCommon } = useMemberPageTranslation()
  const actions = useActions({
    deleteContract
  })

  const [isDeleteLoading, setIsDeleteLoading] = useState(false)

  const handleClickDelete = () => {
    const promise = actions.deleteContract(contractId)
    promise
      .then(() => {
        if (onSubmitSuccess) {
          onSubmitSuccess()
        }
        membershipService.contract.invalidateFetchContracts()
        close()
      })
      .catch(error => {
        setIsDeleteLoading(false)
        setFormError(error)
      })

    setIsDeleteLoading(true)
  }

  return (
    <Alert
      intent='semantic.red'
      title={t('contract.info.form.confirmDeleteTitle')}
    >
      {!futureShifts.length
        ? t('contract.info.form.emptyShift')
        : t('contract.info.form.confirmDelete', {
            count: futureShifts.length
          })}
      <Flex row className='mt-4 justify-end gap-2'>
        <Button
          loading={isDeleteLoading}
          disabled={formLoading}
          type='reset'
          intent='neutral-dark'
          variant='tertiary'
          onClick={hideDeleteConfirm}
          size='m'
        >
          {tCommon('action.cancel')}
        </Button>

        <Button
          loading={isDeleteLoading}
          disabled={formLoading}
          type='submit'
          onClick={handleClickDelete}
          intent='danger'
          size='m'
        >
          {tCommon('action.delete')}
        </Button>
      </Flex>
    </Alert>
  )
}

export default DeleteConfirmMessage
